// Days are always the viewer's browser-local days. This is the only place day boundaries are
// created: never add 24*3600*1000 to cross a day (DST days are 23 or 25 hours long).

// Date-only strings ('YYYY-MM-DD') are local calendar days here; new Date(str) would read
// them as UTC midnight and shift early local-day workouts to the previous day.
export const startOfLocalDay = value => {
    const dateOnly = typeof value === 'string' && /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
    if (dateOnly) return new Date(+dateOnly[1], +dateOnly[2] - 1, +dateOnly[3]);
    const date = new Date(value);
    date.setHours(0, 0, 0, 0);
    return date;
};

export const addLocalDays = (date, n) => {
    const d = startOfLocalDay(date);
    return new Date(d.getFullYear(), d.getMonth(), d.getDate() + n);
};

const pad = n => String(n).padStart(2, '0');

export const localDayKey = value => {
    const d = new Date(value);
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

export const isoWeekNumber = value => {
    const d = startOfLocalDay(value);
    // Calendar arithmetic in UTC: no DST hour can shift a day count. Move to the Thursday of this
    // ISO week, then count whole weeks from that Thursday's Jan 1.
    const thursday = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate() + 3 - ((d.getDay() + 6) % 7));
    const jan1 = Date.UTC(new Date(thursday).getUTCFullYear(), 0, 1);
    return Math.floor(Math.round((thursday - jan1) / 86400000) / 7) + 1;
};

export const startOfLocalWeek = value => {
    const d = startOfLocalDay(value);
    return new Date(d.getFullYear(), d.getMonth(), d.getDate() - ((d.getDay() + 6) % 7));
};

export const weekRange = value => {
    const from = startOfLocalWeek(value);
    return { from, to: new Date(from.getFullYear(), from.getMonth(), from.getDate() + 7) };
};

/** `weeks + 1` local Mondays: the Monday `weeks - 1` weeks before this week's, through next Monday. */
export const weekBoundaries = (now, weeks) => {
    const monday = startOfLocalWeek(now);
    return Array.from({ length: weeks + 1 }, (_, i) =>
        new Date(monday.getFullYear(), monday.getMonth(), monday.getDate() + (i - (weeks - 1)) * 7)
    );
};
